"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var getTld = function (hostname) {
    if (!hostname)
        return null;
    var index = hostname.lastIndexOf('.');
    if (index === -1)
        return null;
    return hostname.substr(hostname.lastIndexOf('.') + 1);
};
exports.default = getTld;
